import styled from 'styled-components';
import Crown from '@paradigm/design-system/src/assets/Crown';
import { paradigmBlue } from '@paradigm/design-system/src/colors';

export default function EmptyTablePage() {
  return (
    <Header>
      <CurvedCrown>
        <Crown />
      </CurvedCrown>
      <Number>404</Number>
      <Message>Leader can&#39;t be found.</Message>
      <SecondMessage>Be the first one!</SecondMessage>
    </Header>
  );
}

const Number = styled.span`
  color: ${paradigmBlue};
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1.5rem;
`;
const Message = styled.span`
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1rem;
`;

const SecondMessage = styled(Message)`
  opacity: 0.7;
`;
const Header = styled.div`
  width: 100%;
  margin: 100px auto;
  display: grid;
  gap: 10px;
`;
const CurvedCrown = styled.div`
  position: relative;
  top: 25px;
  left: -15px; ;
`;
